import { Injectable } from '@angular/core';
import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import { ru } from 'date-fns/locale';
import format from 'date-fns/format';
import isObject from 'lodash/isObject';

import { transformTimeWithoutTimezone } from '../utils/transform-time-without-timezone';

@Injectable({
  providedIn: 'root',
})
export class SkyproDateToStringService {
  /**
   * @deprecated use skyproDate pipe instead
   */
  toLocaleString(date: string | Date, options: Intl.DateTimeFormatOptions): string {
    const language = 'ru-RU';

    if (typeof date === 'string') {
      date = transformTimeWithoutTimezone(date);
    }

    return date.toLocaleString(language, options);
  }

  formatDistanceStrict(start: number, end: number, options?: Object): string {
    const formatOptions = isObject(options) ? options : {};

    return formatDistanceStrict(start, end, {
      locale: ru,
      ...formatOptions,
    });
  }

  /**
   * @deprecated use skyproDate pipe instead
   */
  format(date: string | Date, dateFormat: string, options?: Object): string {
    const locale = ru;
    const formatOptions = isObject(options) ? options : {};

    if (typeof date === 'string') {
      date = transformTimeWithoutTimezone(date);
    }

    return format(date, dateFormat, { locale, ...formatOptions });
  }
}
